const getters = {
  isLoggedIn: state => {
    return !!state.currentUser;
  },

  isFiltered: state => {
    return !!state.searchParams;
  }
};

export default getters;
